import { TextField } from '@mui/material'
import { Controller } from 'react-hook-form'

import CustomTextField from './customTextField'

export default function ControlledTextField({
  label,
  name,
  control = null,
  disabled = false,
  readOnly = false,
  type = "text",
  multiline = false,
  variant = "outlined",
  size = "small",
  rows = 1,
  rules = null
}) {
  return (
    <Controller
      name={name}
      disabled={disabled}
      control={control}
      defaultValue=""
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <CustomTextField 
          label={label}
          readOnly={readOnly}
          type={type}
          multiline={multiline}
          rows={rows}
          error={error}
          helperText={error ? error.message : ""}
          variant={variant}
          size={size}
          {...field}
        />
      )}
    />
  )
}
